import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","color":"red"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","color":"red"} }

import { reactive, watch, ref } from 'vue';
import {pcaTextArr} from "element-china-area-data";
import {ElButton,ElMessage} from "element-plus";
import {values} from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitsView',
  setup(__props) {

const form = reactive({
  userAddress: '',
  year: '',
  money: '',
  money_two: '',
})

const wages = [
  {
    label: '北京市',
    value: [2420],
  },
  {
    label: '天津市',
    value: [2320],
  },
  {
    label: '河北省',
    value: [2200, 2000, 1800],
  },
  {
    label: '山西省',
    value: [1980, 1880, 1780],
  },
  {
    label: '内蒙古自治区',
    value: [1980, 1910, 1850],
  },
  {
    label: '辽宁省',
    value: [2100, 1900, 1700],
  },
  {
    label: '吉林省',
    value: [2120, 1920, 1780],
  },
  {
    label: '黑龙江省',
    value: [2080, 1850, 1750],
  },
  {
    label: '上海市',
    value: [2690],
  },
  {
    label: '江苏省',
    value: [2490, 2260, 2010],
  },
  {
    label: '浙江省',
    value: [2490, 2260, 2010],
  },
  {
    label: '安徽省',
    value: [2060, 1930, 1870, 1780],
  },
  {
    label: '福建省',
    value: [2030, 1960, 1810, 1660],
  },
  {
    label: '江西省',
    value: [2000, 1870, 1740],
  },
  {
    label: '山东省',
    value: [2200, 2010, 1820],
  },
  {
    label: '河南省',
    value: [2100, 2000, 1800],
  },
  {
    label: '湖北省',
    value: [2210, 1950, 1800],
  },
  {
    label: '湖南省',
    value: [2100, 1900, 1700],
  },
  {
    label: '广东省',
    value: [2300, 1900, 1720, 1620],
  },
  {
    label: '深圳市',
    value: [2360],
  },
  {
    label: '广西壮族自治区',
    value: [1990, 1840, 1690],
  },
  {
    label: '海南省',
    value: [2010, 1850],
  },
  {
    label: '重庆市',
    value: [2100, 2000],
  },
  {
    label: '四川省',
    value: [2100, 1970, 1870],
  },
  {
    label: '贵州省',
    value: [1890, 1760, 1660],
  },
  {
    label: '云南省',
    value: [2070, 1920, 1770],
  },
  {
    label: '西藏自治区',
    value: [2100],
  },
  {
    label: '陕西省',
    value: [2160, 2050, 1950],
  },
  {
    label: '甘肃省',
    value: [2020, 1960, 1910, 1850],
  },
  {
    label: '青海省',
    value: [1880],
  },
  {
    label: '宁夏回族自治区',
    value: [2050, 1900],
  },
  {
    label: '新疆维吾尔自治区',
    value: [1900, 1700, 1620, 1540],
  },
  {
    label: '香港特别行政区',
    value: [],
  },
  {
    label: '澳门特别行政区',
    value: [],
  },
  {
    label: '台湾省',
    value: [],
  }
];

const gear = ref([]);

const onSubmit = () => {
  console.log('submit!', form);
  if (!form.userAddress){
    ElMessage({
      message: '请选择所在地区',
      type: 'error',
    });
    return;
  }
  if (!form.year){
    ElMessage({
      message: '请输入工作年限',
      type: 'error',
    });
    return;
  }
  let gearArray = gear.value = form.userAddress[0]
  if (gearArray.length === 0){
    ElMessage({
      message: '输入信息有误',
      type: 'error',
    });
    return;
  }
  // 根据年限计算
  let year = Number(form.year);
  let z = 0;
  if (year === 0) {
    z = 0;
  } else if (year >= 1 && year <= 4) {
    z = 3 * year;
  } else if (year >= 5 && year < 10) {
    z = 12 + (year - 4);
  } else if (year >= 10) {
    z = 24;
  } else {
    ElMessage({
      message: '输入信息有误',
      type: 'warning',
    });
    return;
  }

  console.log('length',gearArray)
  // 根据档位计算金额
  if (gearArray.length === 1) {
    form.money = gearArray[0] * z; // 单个档位
  } else if (gearArray.length >= 2) {
    console.log('value[0]', gearArray[0])
    console.log('z', z)
    form.money = gearArray[0] * z; // 使用第一个档位
    form.money_two = gearArray[gearArray.length - 1] * z; // 使用最后一个档位
  }

  console.log('form', form);
  console.log('form', form.money);
  console.log('gear', gear.value.length);
};

const onReset = () => {
  form.userAddress = '';
  form.year = '';
  form.money = '';
  form.money_two = '';
};

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { style: {"width":"100%"} }, {
      header: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("span", { style: {"font-weight":"bold"} }, "失业保险金预估")
        ], -1)
      ])),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "auto",
          style: {"max-width":"400px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "所在地区：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  placeholder: '请选择所在地区',
                  options: wages,
                  modelValue: form.userAddress,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAddress) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "累计缴纳失业保险年限：",
              prop: "year"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_input, {
                    modelValue: form.year,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.year) = $event)),
                    style: {"max-width":"200px"},
                    placeholder: "请输入工作年数"
                  }, {
                    append: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("年")
                    ])),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (form.money && gear.value.length === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createTextVNode("可领取金额：")),
                    _createElementVNode("span", null, _toDisplayString(form.money), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (form.money && gear.value.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createTextVNode("可领取金额：")),
                    _createElementVNode("span", null, _toDisplayString(form.money_two) + " —— " + _toDisplayString(form.money), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("计算")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(ElButton), { onClick: onReset }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})